//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types

export const OBTENER_MEDIOS_VERIFICACION_PREGUNTA_MUNI = "obtenerMediosVerificacionMuniPeriodo";

export const OBTENER_MEDIOS_VERIFICACION_PREGUNTA_ESPECIFICA_MUNI = "obtenerMediosVerificacionPorPregunta";

export const REGISTRAR_MEDIO_VERIFICACION_PREGUNTA_MUNI = "registrarMedioVerificacionPreguntaMuni";



// mutation types
export const SET_MEDIOS_VERIFICACION_PREGUNTA_MUNI = "setMediosVerificacionPreguntaMuni";
export const SET_MEDIO_VERIFICACION_PREGUNTA_MUNI = "setMedioVerificacionPreguntaMuni";

const state = {
    mediosVerificacion:[],
    medioVerificacion:[],

}

const actions = {

    /**
     * Obtener Listado de MediosVerificacion de la municipalidad a traves de la boletaMuniId
     * @param {*} context 
     * @param {*} indiceId 
     */
     async [OBTENER_MEDIOS_VERIFICACION_PREGUNTA_MUNI](context, boletaMuniId) {

         let endpoint = `api/MedioVerificacionMuni/${boletaMuniId}`
        
         return new Promise(resolve => {
             ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                 .then(({ data }) => {
                     context.commit(SET_MEDIOS_VERIFICACION_PREGUNTA_MUNI, data.data);
                     resolve(data)
                 })
                 .catch((error) => {
                     resolve(error)
                     //context.commit(SET_ERROR, response.data.errors);
                 });
         }); 
    },


    /**
     * Obtener Listado de MediosVerificacion de la pregunta especifica a traves de la boletaMuniId
     * @param {*} context 
     * @param {*} datos 
     */
     async [OBTENER_MEDIOS_VERIFICACION_PREGUNTA_ESPECIFICA_MUNI](context, datos) {

        let endpoint = `api/MedioVerificacionMuni/Boleta/Pregunta/${datos.boletaMuniId}/${datos.preguntaId}`
       
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_MEDIOS_VERIFICACION_PREGUNTA_MUNI, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        }); 
   },


    /**
     * Registrar un medio de verificacion de la municipalidad
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */

    async [REGISTRAR_MEDIO_VERIFICACION_PREGUNTA_MUNI](context, datos){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/MedioVerificacionMuni`, datos)
                .then(({ data }) => {
                    context.commit(SET_MEDIO_VERIFICACION_PREGUNTA_MUNI, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },
}

const mutations = {
    [SET_MEDIO_VERIFICACION_PREGUNTA_MUNI](state, data) {
        state.medioverificacion = data;
    },
    [SET_MEDIOS_VERIFICACION_PREGUNTA_MUNI](state, data) {
        state.mediosverificacion = data;
    },
}


export default {
    state,
    actions,
    mutations
}